import React from 'react';

function Contact() {
  return (
    <div className="survey-container">
      <div className="survey-pattern"></div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="modern-form p-5 fade-in">
              <div className="text-center">
                <div className="survey-icon mx-auto">📧</div>
                <h1 className="survey-title">Contact Us</h1>
                <p className="survey-subtitle">Get in touch with the Meadow Bank Residents team</p>
              </div>
              
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="stat-card h-100">
                    <h5 className="mb-3">Email</h5>
                    <p className="mb-2">
                      <a href="mailto:info@meadowbankresidents.co.uk" className="text-decoration-none">
                        info@meadowbankresidents.co.uk
                      </a>
                    </p>
                    <small className="text-muted">We typically respond within 24 hours</small>
                  </div>
                </div>
                
                <div className="col-md-6 mb-4">
                  <div className="stat-card h-100">
                    <h5 className="mb-3">Office Hours</h5>
                    <p className="mb-1">Monday - Friday: 9:00 AM - 5:00 PM</p>
                    <p className="mb-1">Saturday: Closed</p>
                    <p className="mb-2">Sunday: Closed</p>
                  </div>
                </div>
              </div>
              
              <div className="text-center mt-4">
                <p className="text-muted">
                  If you've had issues with FirstPort then use the <strong>Report Issues</strong> form to record these.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;